import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { AnyIconProps } from './types/any-icon.props';

export const AnyIcon = ({ iconName, ...props }: AnyIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fasr', iconName]}
      {...props}
    />
  );
};
